import DonationDetailPage from '@/core/pages/donation/DonationDetail/DonationDetailPage';

export default DonationDetailPage;
